export default "/assets/arrow-down.png";